import React, { useEffect } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useStores } from 'hooks';
import { sha256 } from 'js-sha256';
import SetPassword from './components/SetPassword';
import resetPasswordMutation from './graphql/resetPassword.graphql';
import _ from 'lodash';

export default observer(({ match }) => {
  const history = useHistory();
  const { authStore } = useStores();

  useEffect(() => {
    if (authStore.isLoggedIn) history.push('/');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authStore.isLoggedIn]);

  const onError = (err) => toast.error(`${err}`);

  const [resetPassword] = useMutation(resetPasswordMutation, {
    fetchPolicy: 'no-cache',
    onError,
  });

  const onSubmit = (data) => {
    resetPassword({ variables: { input: { newPassword: sha256(data.password), token: match.params.token } } })
      .then((r) => {
        toast.success('Password has been set !');
        if (_.get(r, 'data.resetPassword.token')) {
          authStore.changeNewIdentity(r.data.resetPassword.token);
        }
        if (_.get(r, 'data.resetPassword.viewer')) {
          authStore.setViewer(r.data.resetPassword.viewer);
        }
      })
      .catch((err) => {
        toast.error(_.get(err, 'graphQLErrors[0].message'), err);
      });
  };


  return (
    <SetPassword onSubmit={onSubmit} />
  );
});
